import dashboard from './pages/dashboard'
import application from './pages/application'
import createApplication from './pages/createApplication'
import applicationInfo from './pages/applicationInfo'
import statistic from './pages/statistic'
import NotFound from './pages/NotFound'

export default [
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', component: dashboard },
  { path: '/application', component: application },
  { path: '/application/create', component: createApplication },
  { path: '/application/info/:id', component: applicationInfo },
  { path: '/statistic', component: statistic },
  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./src/routes.js